<template>
  <div class="collision-record">
    <div class="flex justify-between">
      <div class="flex-wrap pl20 pr20">
        <div class="flex-al mb10 mr10">
          <span class="fs14 color-666"> 撞单时间： </span>
          <div class="time-box">
            <el-date-picker
              v-model="selectForm.range_time"
              type="daterange"
              style="width: 260px"
              :range-separator="$t('Common.to')"
              value-format="yyyy-MM-dd"
              :start-placeholder="$t('Common.startTime')"
              :end-placeholder="$t('Common.endTime')"
              @change="handleSelect()"
            ></el-date-picker>
          </div>
        </div>
        <div class="flex-al mb10 mr10">
          <div class="select-box">
            <el-select
              @change="handleSelect"
              v-model="selectForm.conflicts_issuccess"
              clearable
              filterable
              class="select-mini"
              style="width: 200px"
              placeholder="请选择撞单结果"
            >
              <el-option label="失败" value="0"></el-option>
              <el-option label="成功" value="1"></el-option>
            </el-select>
          </div>
        </div>
        <div class="flex-al Inquire-box mb10">
          <div class="ipt-box">
            <el-input
              clearable
              style="width: 240px"
              placeholder="请输入名单姓名、手机号"
              class="input-cont"
              v-model="selectForm.keyword"
              @change="handleSelect()"
            ></el-input>
          </div>
          <el-button
            type="primary"
            class="btn-inquire"
            style="margin-right: 0px"
            @click="handleSelect()"
          >
            {{ $t("Customersmanage.an") }}
          </el-button>
        </div>
      </div>
      <div class="ml20 mr20">
        <el-button type="primary" @click="handleExport()">导出</el-button>
      </div>
    </div>
    <div class="pl20 pr20">
      <div
        class="table-list"
        style="position: relative"
        ref="auto_height_table"
      >
        <normalTableCont :tableData="tableList">
          <template v-slot:diy-slot="{ scope }">
            <template
              v-if="scope.column.property == 'channel_issuccess_name'"
            >
              <div
                class="content-row-status"
                :class="{
                  'content-row-status-success':
                    scope.row.channel_issuccess == 1,
                  'content-row-status-fail': scope.row.channel_issuccess == 0,
                }"
              >
                {{ scope.row.channel_issuccess_name }}
              </div>
            </template>
            <template
              v-if="scope.column.property == 'conflicts_issuccess_name'"
            >
              <div
                class="content-row-status"
                :class="{
                  'content-row-status-success':
                    scope.row.conflicts_issuccess == 1,
                  'content-row-status-fail': scope.row.conflicts_issuccess == 0,
                }"
              >
                {{ scope.row.conflicts_issuccess_name }}
              </div>
            </template>
          </template>
          <el-table-column
            ref="fixedColumn"
            label="操作"
            align="center"
            width="120px"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                type="text"
                size="small"
                @click.native.prevent="handleColumnChange(scope.row)"
              >
                查看
              </el-button>
            </template>
          </el-table-column>
        </normalTableCont>
      </div>
      <el-pagination
        style="margin-top: 20px"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="paging.currentPage"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="paging.pagesize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="paging.dataNumber"
      ></el-pagination>
    </div>

    <SliderBox :showSliderBox="showDetailPop" :sliderWidth="minSliderwidth">
      <div class="silder-contain slider-channel-record">
        <div class="slider-top clearFloat">
          <p class="h3 slider-title pull-left">
            {{ $t("views.Customersmanage.channelRecord.5zrpeqo9m740") }}
          </p>
          <el-button
            type="default"
            class="pull-right"
            @click="showDetailPop = false"
          >
            {{ $t("Customersmanage.dbg") }}
          </el-button>
        </div>
        <div class="slider-cont text-1 pop-channel-user">
          <div class="user-header mb10" v-if="rowData">
            <div class="user-header__img">
              <img
                :src="
                  rowData.client_img ||
                  (rowData.client_sex ==
                  $t('views.Customersmanage.channelRecord.5zrpeqo9nq40')
                    ? require('@/assets/images/default-img-man.png')
                    : require('@/assets/images/default-img-women.png'))
                "
                alt=""
              />
            </div>
            <div class="user-header__desc">
              <p class="desc">
                {{ rowData.client_cnname }}
                <img
                  class="ml10 mr10"
                  :src="
                    rowData.client_sex ==
                    $t('views.Customersmanage.channelRecord.5zrpeqo9nq40')
                      ? require('@/assets/images/icon/icon-person-men.png')
                      : require('@/assets/images/icon/icon-person-women.png')
                  "
                  alt=""
                />
                <span v-if="rowData.status == 1" class="tag-normal mr15">
                  {{ $t("Customersmanage.dbf") }}</span
                >
                <span
                  class="tag-status"
                  :class="{
                    'tag-red': rowData.channellog_level == 2,
                    'tag-yellow': rowData.channellog_level == 1,
                    'tag-blue': rowData.channellog_level == 0,
                  }"
                >
                  {{
                    rowData.channellog_level == 2
                      ? $t("views.Customersmanage.channelRecord.5zrpeqo9ny00")
                      : rowData.channellog_level == 1
                      ? $t("views.Customersmanage.channelRecord.5zrpeqo9o340")
                      : $t("views.Customersmanage.channelRecord.5zrpeqo9o7c0")
                  }}
                </span>
              </p>
              <table>
                <tr>
                  <td>
                    <span>{{
                      $t("views.Customersmanage.channelRecord.5zrpeqo9ocw0")
                    }}</span
                    >{{ rowData.from_channel_medianame }}
                  </td>
                  <td>
                    <span>{{
                      $t("views.Customersmanage.channelRecord.5zrpeqo9ogw0")
                    }}</span
                    >{{ rowData.from_channel_medianame }}
                  </td>
                </tr>
                <tr>
                  <td>
                    <span>{{
                      $t("views.Customersmanage.channelRecord.5zrpeqo9ol00")
                    }}</span
                    >{{ rowData.to_channel_medianame }}
                  </td>
                  <td>
                    <span>{{
                      $t("views.Customersmanage.channelRecord.5zrpier5rjw0")
                    }}</span
                    >{{ rowData.to_channel_name }}
                  </td>
                </tr>
              </table>
            </div>
            <div
              v-if="rowData.channellog_status != 0"
              class="notice-tags"
              :class="{
                'notice-success': rowData.channellog_status == 1,
                'notice-fail': rowData.channellog_status == -1,
              }"
            >
              <span>
                {{
                  rowData.channellog_status == 1
                    ? $t("views.Customersmanage.channelRecord.5zrpeqo9op00")
                    : rowData.channellog_status == -1
                    ? $t("views.Customersmanage.channelRecord.5zrpeqo9p7s0")
                    : ""
                }}</span
              >
            </div>
          </div>
          <el-tabs class="channel-view__tabs" v-model="applyActive">
            <el-tab-pane
              :label="$t('views.Customersmanage.channelRecord.5zrpeqo9pks0')"
              name="first"
            >
              <p class="form-small-title h3 mt5">
                {{ $t("views.Customersmanage.channelRecord.5zrpeqo9pks0") }}
              </p>
              <ul class="channel-apply-info" v-if="rowData">
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9pq00")
                  }}</span
                  ><span class="desc">{{ rowData.school_cnname }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9pto0")
                  }}</span
                  ><span class="desc">{{ rowData.client_age }}岁</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9pww0")
                  }}</span
                  ><span class="desc">{{ rowData.family_relation }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9q040")
                  }}</span
                  ><span class="desc">{{ rowData.client_mobile }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9q3c0")
                  }}</span
                  ><span class="desc">{{ rowData.client_createtime }}</span>
                </li>
                <li>
                  <span class="tit">{{
                    $t("views.Customersmanage.channelRecord.5zrpeqo9q6c0")
                  }}</span
                  ><span class="desc">{{ rowData.client_remark }}</span>
                </li>
              </ul>
            </el-tab-pane>
            <el-tab-pane
              :label="$t('views.Customersmanage.channelRecord.5zrpeqo9q9c0')"
              name="second"
            >
              <div class="slider-trackRecord">
                <div class="record-info">
                  <p class="form-small-title h3 mt5">
                    {{ $t("User.s_title7") }}
                  </p>
                  <el-row v-for="(items, index) in trackList" :key="index">
                    <el-col :span="4">
                      <div class="grid-content bg-purple grid-content-img">
                        <img
                          :src="
                            items.marketer_img ||
                            (items.staffer_sex ==
                            $t(
                              'views.Customersmanage.channelRecord.5zrpeqo9nq40'
                            )
                              ? require('@/assets/images/default-img-man.png')
                              : require('@/assets/images/default-img-women.png'))
                          "
                        />
                      </div>
                    </el-col>
                    <el-col :span="20">
                      <div class="grid-content bg-purple-light text-1">
                        <p class="clearFloat">
                          {{ items.marketer_name }}
                          <span
                            v-if="items.track_linktype != ''"
                            class="btn-purple font-gray"
                            >{{ items.track_linktype }}</span
                          >
                          <span
                            v-if="items.track_followcont != ''"
                            class="btn-purple font-gray"
                            >{{ items.track_followcont }}</span
                          >
                          <span class="font-gray show-time pull-right">{{
                            items.track_createtime
                          }}</span>
                        </p>
                        <p>
                          {{ $t("User.follow_label2") }}{{ items.object_name }}
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p v-if="items.track_followmode == '2'">
                          {{ $t("User.tryClass") }}{{ items.class_cnname }}
                        </p>
                        <p v-if="items.track_followmode == '1'">
                          {{ $t("User.guiDate") }}{{ items.track_visitingtime }}
                        </p>
                        <p
                          v-if="
                            items.track_followuptime &&
                            items.track_followuptime != ''
                          "
                        >
                          {{ $t("User.nextFollowDate")
                          }}{{ items.track_followuptime }}
                        </p>
                        <div class="flex-all">
                          <p>
                            {{ $t("User.followSchool") }}
                            {{ items.school_cnname }}
                          </p>
                          <p
                            v-if="items.track_isreading == '1'"
                            class="text-3 mb10"
                          >
                            {{ items.level_marketer_name }}
                            <span class="font-gray"
                              >{{ $t("User.label_text20")
                              }}{{ items.track_readtime
                              }}{{ $t("User.btn_text4") }}</span
                            >
                          </p>
                        </div>
                        <!-- 回复列表 -->
                        <div
                          v-if="
                            items.replay_info && items.replay_info.length > 0
                          "
                          class="replay-list"
                        >
                          <div
                            v-for="(item1, index1) in items.replay_info"
                            :key="index1"
                            class="communite-replay"
                          >
                            <div class="img mt20 mb10">
                              <img
                                :src="
                                  item1.marketer_img ||
                                  (item1.staffer_sex ==
                                  $t(
                                    'views.Customersmanage.channelRecord.5zrpeqo9nq40'
                                  )
                                    ? require('@/assets/images/default-img-man.png')
                                    : require('@/assets/images/default-img-women.png'))
                                "
                              />
                            </div>
                            <div class="replay-cont">
                              <div class="replay-top mt20 mb10">
                                <span>
                                  {{ item1.marketer_name }}
                                  <span class="font-gray ml5 mr5">{{
                                    $t("User.btn_text6")
                                  }}</span>
                                  {{ items.marketer_name }}
                                </span>
                                <span class="font-gray">{{
                                  item1.replay_createtime
                                }}</span>
                              </div>
                              <p>{{ item1.replay_note }}</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </el-col>
                  </el-row>
                  <p class="no-data" v-if="trackList.length == 0">
                    <i class="crm-wu"></i>
                    {{ $t("User.noFollowRecord") }}
                  </p>
                </div>
              </div>
            </el-tab-pane>
            <el-tab-pane name="third">
              <span slot="label"
                >{{ $t("Customersmanage.dbj") }}
                <em v-if="channelChangeApplyNum > 0" class="tab-num-tips">{{
                  channelChangeApplyNum
                }}</em></span
              >
              <p class="form-small-title h3 mt5">
                {{ $t("Customersmanage.dbj") }}
              </p>
              <div
                v-for="(activity, index) in channelChangeList"
                :key="index"
                class="channel-history"
              >
                <div class="channel-history__title">
                  {{ activity.createtime }}
                </div>
                <div class="channel-history-box">
                  <div class="channel-row">
                    <div class="channel-detail">
                      <div class="channel-detail__content">
                        <p>{{ activity.from_frommedia_name }}</p>
                        <p>{{ activity.from_channel_name }}</p>
                        <p>{{ activity.channellog_client_frompage }}</p>
                      </div>
                      <div class="channel-detail__tips">
                        <img src="@/assets/images/change-icon.png" alt="" />
                        <p>{{ $t("Customersmanage.dbl") }}</p>
                      </div>
                      <div class="channel-detail__content">
                        <p>{{ activity.to_frommedia_name }}</p>
                        <p>{{ activity.to_channel_name }}</p>
                        <p>&nbsp;</p>
                      </div>
                    </div>
                    <div
                      class="channel-status"
                      :class="{
                        'status-success': activity.tracks_title == 1,
                        'status-fail': activity.tracks_title == -1,
                        'status-wait': activity.tracks_title == 0,
                      }"
                    >
                      <span class="dot"></span>
                      {{
                        activity.tracks_title == "0"
                          ? $t("Customersmanage.dbk")
                          : activity.tracks_title == "1"
                          ? $t(
                              "views.Customersmanage.channelRecord.5zrpeqo9op00"
                            )
                          : activity.tracks_title == "-1"
                          ? $t(
                              "views.Customersmanage.channelRecord.5zrpeqo9p7s0"
                            )
                          : ""
                      }}
                    </div>
                  </div>
                  <template v-if="activity.tracks_title == 0">
                    <p class="channel-history__teacher">
                      {{ $t("Customersmanage.dbm") }}：{{
                        activity.staffer_cnname
                      }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbn") }}：
                      {{ activity.channellog_changetime || "--" }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbo") }}：
                      {{ activity.channellog_reason }}
                    </p>
                    <!-- <p
                      v-if="activity.channellog_img"
                      class="channel-history__teacher"
                    >
                      {{$t('views.Customersmanage.channelRecord.5zrpeqo9qd00')}}
                      <span
                        @click="
                          (showImgUrl = activity.channellog_img),
                            (showImgMask = true)
                        "
                        style="color: #20a8d8; cursor: pointer;"
                        >{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</span
                      >
                    </p> -->
                    <p
                      v-if="activity.channellog_imgjson"
                      class="channel-history__teacher"
                    >
                      {{ $t("Customersmanage.dbp") }}：
                      <span
                        @click="
                          (showImgUrlArr = activity.channellog_imgjson),
                            (showImgMask = true),
                            onPreview(activity.channellog_imgjson)
                        "
                        style="color: #20a8d8; cursor: pointer"
                        >{{ $t("Customersmanage.dbr") }}</span
                      >
                    </p>

                    <!-- <div v-if="activity.channellog_imgjson">
                      <el-button type="text" @click="onPreview(activity.channellog_imgjson)">{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</el-button>
                      <el-image-viewer
                        v-if="showViewer"
                        :on-close="closeViewer"
                        :url-list="url"
                        >
                      </el-image-viewer>
                    </div> -->
                  </template>
                  <template v-else>
                    <p class="channel-history__teacher">
                      审核人：{{ activity.astaffer_cnname }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbn") }}：
                      {{ activity.channellog_changetime || "--" }}
                    </p>
                    <p class="mt10">
                      {{ $t("Customersmanage.dbo") }}：
                      {{ activity.channellog_note }}
                    </p>
                    <!-- <p
                      v-if="activity.channellog_img"
                      class="channel-history__teacher"
                    >
                      {{$t('views.Customersmanage.channelRecord.5zrpeqo9qd00')}}
                      <span
                        @click="
                          (showImgUrl = activity.channellog_img),
                            (showImgMask = true)
                        "
                        style="color: #20a8d8; cursor: pointer;"
                        >{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</span
                      >
                    </p> -->
                    <p
                      v-if="activity.channellog_imgjson"
                      class="channel-history__teacher"
                    >
                      {{
                        $t("views.Customersmanage.channelRecord.5zrpeqo9qd00")
                      }}
                      <span
                        @click="
                          (showImgUrlArr = activity.channellog_imgjson),
                            (showImgMask = true),
                            onPreview(activity.channellog_imgjson)
                        "
                        style="color: #20a8d8; cursor: pointer"
                        >{{ $t("Customersmanage.dbr") }}</span
                      >
                    </p>

                    <!-- <div v-if="activity.channellog_imgjson">
                      <el-button type="text" @click="onPreview(activity.channellog_imgjson)">{{$t('views.Customersmanage.channelRecord.5zrpeqo9qg40')}}</el-button>
                      <el-image-viewer
                        v-if="showViewer"
                        :on-close="closeViewer"
                        :url-list="url"
                        >
                      </el-image-viewer>
                    </div> -->
                  </template>
                </div>
              </div>
              <p v-if="channelChangeList.length == '0'" class="no-data">
                <i class="el-icon-document"></i>
                {{ $t("views.Customersmanage.channelRecord.5zrpeqo9qk00") }}
              </p>
            </el-tab-pane>
          </el-tabs>
        </div>
      </div>
    </SliderBox>

    <div id="viewerStyle" v-if="showImgMask">
      <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :url-list="url"
      >
      </el-image-viewer>
    </div>
  </div>
</template>
<script>
import ElImageViewer from "../../../../node_modules/element-ui/packages/image/src/image-viewer";
import SliderBox from "@/components/SliderBox";
import normalTableCont from "@/components/tables/switchTableCont.vue";
import channelRecordRequest from "../channelRecord.js";
export default {
  name: "CustoMersmanage-custoMersmanage",
  data() {
    return {
      token: "",
      marketer_id: "",
      school_id: "",
      company_id: "",
      re_postbe_id: "",
      language_type: "",
      postbe_crmlevel: "",
      postbe_crmuserlevel: "",

      showViewer: false, // 显示查看器
      url: [],

      showImgUrlArr: [],
      showImgMask: false,
      showImgUrl: "",

      showSliderBoxSee: false,

      rowData: {},
      showDetailPop: false,
      applyActive: "first",
      channelChangeList: [],
      channelChangeApplyNum: 0,
      trackList: [],

      paging: {
        dataNumber: 0, //数据总数
        pagenum: 1,
        pagesize: 10,
        currentPage: 1,
      },

      selectForm: {
        range_time: "",
        keyword: "",
        conflicts_issuccess: "",
      },

      sliderWidth: "700px", //侧边栏宽度
      minSliderwidth: "620px",

      tableList: {
        list: [],
        columns: [],
        options: {
          mutiSelect: false,
          tableHeight: null, //表格高度
          errortip: "",
          issetting: false,
        },
      },
    };
  },
  components: {
    SliderBox,
    ElImageViewer,
    normalTableCont,
  },
  updated() {},
  watch: {
    showDetailPop(n) {
      if (!n) {
        this.applyActive = "first";
      }
    },

    applyActive(n) {
      if (n == "third") {
        this.getChannelTrack();
      } else if (n == "second") {
        this.clientOneTrackApi();
      }
    },
  },
  created() {
    this.slider = this.$store.state.Slider;
    this.token = this.$store.state.USER_TOKEN;
    this.marketer_id = this.$store.state.MARKETER_ID;
    this.school_id = this.$store.state.SCHOOL_ID;
    this.company_id = this.$store.state.COMPANY_ID;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";
    this.re_postbe_id = this.$Tool.getStorage("re_postbe_id")
      ? this.$Tool.getStorage("re_postbe_id")
      : "";
    this.language_type = this.$Tool.getStorage("language")
      ? this.$Tool.getStorage("language")
      : "";
    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.postbe_crmuserlevel = this.$Tool.getStorage("PostbeCrmlevel")
      ? this.$Tool.getStorage("PostbeCrmlevel")
      : "";

    // 设置默认时间为近30天
    const today = new Date();
    const thirtyDaysAgo = new Date(today.getTime() - 30 * 24 * 60 * 60 * 1000);

    this.selectForm.range_time = [
      this.$Common.getDateStr3(thirtyDaysAgo),
      this.$Common.getDateStr3(today),
    ];

    // 权限判断
    this.postbe_crmlevel = this.$store.state.POSTBE_CRMLEVEL;
    this.getClientConflicts();
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs["auto_height_table"]) {
        this.tableList.options.tableHeight = this.$Common.getTableHeight(
          this.$refs.auto_height_table.getBoundingClientRect().top + 85
        );
      }
    });
  },
  methods: {
    handleExport() {
      let params_str = "";
      let start_time = this.selectForm.range_time
        ? this.selectForm.range_time[0]
        : "";
      let end_time = this.selectForm.range_time
        ? this.selectForm.range_time[1]
        : "";
      params_str = `&keyword=${this.selectForm.keyword}&conflicts_issuccess=${this.selectForm.conflicts_issuccess}&start_time=${start_time}&end_time=${end_time}`;
      let url = channelRecordRequest.getClientConflicts1();
      params_str = `${url}?marketer_id=${this.marketer_id}&token=${this.token}&school_id=${this.school_id}&company_id=${this.company_id}&re_postbe_id=${this.re_postbe_id}&postbe_crmuserlevel=${this.postbe_crmuserlevel}&language_type=${this.language_type}&is_export=1${params_str}`;
      if (this.tableList.list.length > 0) {
        window.open(this.$buildExportUrl(params_str), "_blank");
      } else {
        this.$message.error(this.$t("Common.exportTips"));
      }
    },
    onPreview(img) {
      this.url = img;
      this.showViewer = true;
    },
    closeViewer() {
      this.showViewer = false;
    },
    clientOneTrackApi() {
      channelRecordRequest
        .clientOneTrackApi({
          client_id: this.rowData.client_id,
        })
        .then((res) => {
          this.trackList = [];
          const { data } = res.data;
          data.list.forEach((item) => {
            var str = item.track_followmode_name;
            this.trackList.push(
              Object.assign({}, item, {
                track_followcont: str,
                isClickReply: false,
                replay_note: "",
              })
            );
          });
        });
    },
    getChannelTrack() {
      channelRecordRequest
        .getChannelTrack({
          client_id: this.rowData.client_id,
          channellog_id: this.rowData.channellog_id,
        })
        .then((res) => {
          console.warn(res);
          const { code, data: _jb } = res.data;

          const data = _jb;
          if (code === 200) {
            this.channelChangeList = data.data;
            this.channelChangeApplyNum = parseInt(data.num) || 0;
            // this.srcList = data.data[0].channellog_imgjson;
            // (() => {})(this.srcList);
          } else {
            this.channelChangeList = [];
          }
        });
    },
    getClientConflicts() {
      channelRecordRequest
        .getClientConflicts({
          is_count: "1", //是否需要总数，可以不传
          p: this.paging.currentPage,
          num: this.paging.pagesize,
          postbe_crmuserlevel: this.postbe_crmlevel,

          keyword: this.selectForm.keyword,
          conflicts_issuccess: this.selectForm.conflicts_issuccess,
          start_time: this.selectForm.range_time
            ? this.selectForm.range_time[0]
            : "",
          end_time: this.selectForm.range_time
            ? this.selectForm.range_time[1]
            : "",
        })
        .then((res) => {
          const { code, data, msg } = res.data;
          this.paging.dataNumber = parseInt(data.all_num);
          var Columns = data.field;

          Columns.forEach((v) => {
            if (v.fieldname == "conflicts_issuccess_name" || v.fieldname == "channel_issuccess_name") {
              v.diyCotnent = 1;
            }
          });
          this.tableList.columns = Columns;
          if (code === 200) {
            this.tableList.list = data.list;
          } else {
            this.tableList.list = [];
            this.tableList.options.errortip = msg;
          }
        });
    },
    handleSelect() {
      this.paging.pagenum = 1;
      this.getClientConflicts();
    },
    handleColumnChange(v) {
      // this.rowData = { ...v };
      // this.getChannelTrack();
      // this.clientOneTrackApi();
      // this.showDetailPop = true;

      this.$router.push({
        path: "/Customersmanage/CollisionDetail",
        query: {
          conflicts_id: v.conflicts_id,
        },
      });
    },
    handleSizeChange(val) {
      this.paging.pagesize = val;
      this.paging.currentPage = 1;
      this.getClientConflicts();
    },
    handleCurrentChange(val) {
      this.paging.currentPage = val;
      this.getClientConflicts();
    },
  },
};
</script>
<style lang="less">
@import url("../../../assets/less/manage.less");
@import url("../channelRecord.less");
.show-img__mask {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.5);
  z-index: 10000000;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
.channelRecord {
  height: 100vh;
  font-size: 20px;
  .apply-channel__desc {
    display: flex;
    margin: 0 -20px;
    line-height: 35px;
    align-items: center;
    justify-content: center;
    color: rgba(32, 168, 216, 1);
    background-color: rgba(32, 168, 216, 0.14);
  }
  .apply-channel__notice {
    color: red;
  }
  .apply-user-pop {
    display: flex;
    padding: 20px;
    align-items: center;
    .user-info__img {
      width: 100px;
      padding-right: 13px;
      display: flex;
      justify-content: flex-end;
      img {
        display: block;
        width: 53px;
        height: 53px;
        border-radius: 50%;
      }
    }
    .user-info__name {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #333333;
      line-height: 30px;
      display: flex;
      align-items: center;
      .user-tips {
        margin-left: 20px;
        padding: 0 8px;
        font-size: 14px;
        line-height: 30px;
        font-style: normal;
        color: rgba(32, 168, 216, 1);
        border-radius: 5px;
        background-color: rgba(32, 168, 216, 0.05);
      }
    }
  }
  .choose-user-row {
    display: flex;
    padding: 0 20px;
    .tit {
      width: 100px;
    }

    .user-content {
      flex: 1;
      padding-top: 2px;
      margin-bottom: 0px;
      display: flex;
      flex-wrap: wrap;
    }

    .user-content-item {
      margin: 0 30px 15px 0;
      position: relative;
      .el-icon-circle-close {
        top: -5px;
        right: -15px;
        position: absolute;
        color: red;
        cursor: pointer;
        &:hover {
          color: #20a8d8;
        }
      }
    }
  }

  .slider-channel-record {
    .user-header {
      display: flex;
      padding-top: 20px;
      align-items: flex-start;
      position: relative;
      .user-header__desc {
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 30px;
        .desc {
          display: flex;
          margin-bottom: 5px;
          align-items: center;
        }
        .desc-sex__img {
          margin: 0 15px 0 5px;
        }
        .tag-normal {
          padding: 0 5px;
          font-size: 14px;
          font-family: MicrosoftYaHei;
          color: #20a8d8;
          line-height: 26px;
          border: 1px solid #20a8d8;
          border-radius: 3px;
        }
        .tag-status {
          padding: 0 6px;
          line-height: 26px;
          font-size: 14px;
          color: #fff;
          border-radius: 4px;
        }
        .tag-red {
          background: #f35c5c;
        }
        .tag-blue {
          background: #20a8d8;
        }
        .tag-yellow {
          background: #f8cd09;
        }
      }
      .notice-tags {
        right: 20px;
        top: 20px;
        width: 98px;
        height: 98px;
        position: absolute;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        span {
          transform: rotate(-15deg);
          position: relative;
        }
        &.notice-success {
          color: #20a8d8;
          border: 1px solid #20a8d8;
        }
        &.notice-fail {
          color: #f35c5c;
          border: 1px solid #f35c5c;
        }
      }
      .user-header__img {
        margin-right: 10px;
      }
      td {
        width: 200px;
        line-height: 30px;
      }
    }

    .channel-apply-info {
      li {
        margin-bottom: 15px;
        font-size: 14px;
      }
      .tit {
        color: #aaa;
      }
      .desc {
        color: #666;
      }
    }
  }

  .channel-view__tabs {
    .el-tabs__nav {
      padding-left: 0;
    }
  }
  .slider-channel-record {
    .el-row .grid-content-img img {
      height: 100%;
    }
    .slider-studentBind .el-row .el-col {
      min-height: 178px;
    }
    .el-row .grid-content > p {
      height: auto;
    }
    .el-row .grid-content .communite-cont {
      line-height: 28px;
      display: flex;
      justify-content: space-between;
      p {
        flex: 1;
      }
      .btns {
        width: 135px;
        margin-left: 10px;
        .el-button {
          width: 60px;
        }
        .btn-disabled {
          background-color: #cccccc;
          border-color: #cccccc;
        }
      }
    }
    .el-row .grid-content .communite-replay {
      display: flex;
      border-top: 1px dashed #ddd;
      .replay-cont {
        flex: 1;
        line-height: 24px;
      }
      .img {
        width: 40px;
        height: 40px;
        overflow: hidden;
        border-radius: 50%;
        margin-right: 10px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .replay-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }
  }
  .channel-history {
    margin: 0 0 0 10px;
    padding-bottom: 10px;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      left: 0;
      top: 10px;
      width: 1px;
      height: 100%;
      background-color: rgba(40, 171, 217, 1);
      border-radius: 50%;
    }
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      margin-bottom: 20px;
    }
    .channel-history__title {
      margin: 0 0 10px 0;
      padding-left: 15px;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #a4a4a4;
      line-height: 20px;
      letter-spacing: 1px;
      position: relative;
      &::before {
        content: "";
        position: absolute;
        left: -5px;
        top: 5px;
        width: 6px;
        height: 6px;
        padding: 2px;
        border: 1px solid rgba(0, 173, 223, 1);
        background-color: rgba(0, 173, 223, 1);
        background-clip: content-box;
        border-radius: 50%;
      }
    }
    .channel-history-box {
      width: 96%;
      margin: 0 auto;
      padding: 20px 30px;
      box-shadow: 0px 2px 16px 0px rgba(0, 0, 0, 0.08);
      .channel-row {
        display: flex;
        align-items: flex-start;
        .channel-detail {
          display: flex;
          flex: 5;
          padding: 16px 0;
          align-items: center;
          justify-content: space-around;
          background-color: rgba(32, 168, 216, 0.05);
          .channel-detail__content {
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 14px;
            font-family: MicrosoftYaHei;
            color: #3a3a3a;
            line-height: 19px;
            letter-spacing: 1px;
            p {
              margin-top: 20px;
              &:first-child {
                margin-top: 0;
              }
            }
          }
          .channel-detail__tips {
            display: flex;
            flex-direction: column;
            align-items: center;
            img {
              width: 47px;
              height: 25px;
            }
            p {
              font-size: 12px;
              font-family: MicrosoftYaHei;
              color: #aaaaaa;
              line-height: 16px;
              letter-spacing: 1px;
            }
          }
        }
        .channel-status {
          flex: 2;
          display: flex;
          align-items: center;
          justify-content: flex-end;
          .dot {
            width: 6px;
            height: 6px;
            margin-right: 5px;
            border-radius: 50%;
          }
          &.status-success {
            color: rgba(32, 168, 216, 1);
            .dot {
              background-color: rgba(32, 168, 216, 1);
            }
          }
          &.status-fail {
            color: rgba(243, 92, 92, 1);
            .dot {
              background-color: rgba(243, 92, 92, 1);
            }
          }
          &.status-wait {
            color: rgba(6, 217, 3, 1);
            .dot {
              background-color: rgba(6, 217, 3, 1);
            }
          }
          &.status-warn {
            color: rgba(255, 203, 0, 1);
            .dot {
              background-color: rgba(255, 203, 0, 1);
            }
          }
        }
      }
    }
    .channel-history__teacher {
      margin-top: 20px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      color: #55606e;
      line-height: 19px;
      letter-spacing: 1px;
      &:last-child {
        margin-top: 10px;
      }
    }
  }
  .tab-num-tips {
    display: inline-block;
    width: 16px;
    height: 16px;
    margin-left: -8px;
    font-size: 13px;
    color: #fff;
    line-height: 100%;
    font-style: normal;
    text-align: center;
    line-height: 16px;
    vertical-align: top;
    background-color: red;
    border-radius: 50%;
  }
}
#viewerStyle {
  .el-image-viewer__wrapper {
    position: fixed;
    background: rgba(0, 0, 0, 0.3);
    top: 0px;
    left: 0px;
    max-height: 100%;
    max-width: 100%;
    width: 100%;
    height: 100%;
  }
  .el-image-viewer__btn {
    color: #777;
  }
  .el-image-viewer__close {
    position: absolute;
    right: 0;
    z-index: 20000000;
  }
  .el-image-viewer__prev {
    position: absolute;
    top: 50%;
    left: 5%;
    z-index: 20000000;
  }
  .el-image-viewer__next {
    position: absolute;
    top: 50%;
    right: 5%;
    z-index: 20000000;
  }
  .el-icon-arrow-left {
    font-size: 80px;
  }
  .el-icon-arrow-right {
    font-size: 80px;
  }
  .el-icon-circle-close {
    font-size: 40px;
  }
  .el-icon-zoom-out {
    font-size: 40px;
  }
  .el-icon-zoom-in {
    font-size: 40px;
  }
  .el-icon-full-screen {
    font-size: 40px;
  }
  .el-icon-refresh-left {
    font-size: 40px;
  }
  .el-icon-refresh-right {
    font-size: 40px;
  }
  .el-icon-arrow-left:hover,
  .el-icon-arrow-right:hover,
  .el-icon-circle-close:hover,
  .el-icon-zoom-out:hover,
  .el-icon-zoom-in:hover,
  .el-icon-full-screen:hover,
  .el-icon-refresh-left:hover,
  .el-icon-refresh-right:hover {
    cursor: pointer;
  }
  .el-image-viewer__actions__inner {
    position: absolute;
    left: 50%;
    bottom: 5%;
    z-index: 20000000;
    background-color: #888;
  }
  .el-image-viewer__canvas img {
    margin: auto !important;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
  }
}
</style>
<style lang="less" scoped>
.content-row-status {
  display: inline;
  vertical-align: middle;
  text-align: center;
  font-size: 13px;
  &.content-row-status-success {
    color: rgba(82, 196, 26, 1) !important;
    border: 1px solid rgba(82, 196, 26, 1);
    background-color: #f0f9eb;
    border-radius: 5px;
    padding: 3px 6px;
  }
  &.content-row-status-fail {
    color: #ff0000 !important;
    border: 1px solid #ff0000;
    background-color: #fff0f0;
    border-radius: 5px;
    padding: 3px 6px;
  }
}
</style>
